var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"default","flat":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Закрыть")])}
var staticRenderFns = []

export { render, staticRenderFns }